import React, { useEffect, useState } from 'react';
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { NewsItemDetail } from "../../components/News/NewsItemDetail";
import { useHttp } from "../../hooks/use-http";
import { NewsItemSideBar } from "../../components/Sidebar/News/NewsItemSideBar";
import Volunteering from '../../components/Sidebar/General/Volunteering';
import BecomeAMember from '../../components/Sidebar/General/BecomeAMember';
import { LoadingNewsItem } from "../../components/Extra/Loading/LoadingNewsItem";
import { StyledSectionHeaderComponent, StyledListContainer, StyledListSection } from "../../utils/common-styles";
import { Helmet } from "react-helmet";

export const NewsDetailPage = (props) => {

    const { id, slug } = useParams();
    const [newsItem, setNewsItem] = useState({});
    const [otherNews, setOtherNews] = useState([]);
    const { isLoading, error, sendRequest: getContent } = useHttp();

    useEffect(() => {

        const parseContent = (data) => {
            let newsItem = data?.payload?.item;
            let otherNews = data?.payload?.other;
            setNewsItem((prevState) => {
                return { ...prevState, ...newsItem };
            });

            setOtherNews((prevState) => {
                return otherNews;
            });
        }

        let url = `/news/item/${id}/detail`;
        getContent({ url }, parseContent);
    }, [id, slug, getContent]);

    return (
        <>
            <Helmet>
                <title>{newsItem?.title ? `${newsItem.title} - Friends of Queen's Wood` : 'Friends of Queen\'s Wood'}</title>
                <meta name="description" content={newsItem?.intro || 'We are a group of volunteers that help to look after the wood'} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={newsItem?.title || 'Friends of Queen\'s Wood'} />
                <meta property="og:description" content={newsItem?.intro || 'We are a group of volunteers that help to look after the wood'} />
                <meta property="og:url" content={`${window.location.origin}/news/${id}/${slug}`} />
                <meta property="og:image" content={newsItem?.image_details?.variations?.detail_hero || '%PUBLIC_URL%/assets/og-large-profile.jpg'} />
                <meta name="twitter:title" content={newsItem?.title || 'Friends of Queen\'s Wood'} />
                <meta name="twitter:description" content={newsItem?.intro || 'We are a group of volunteers that help to look after the wood'} />
                <meta name="twitter:image" content={newsItem?.image_details?.variations?.detail_hero || '%PUBLIC_URL%/assets/og-large-profile.jpg'} />
            </Helmet>
            <StyledSectionHeaderComponent title="News from the Wood" />
            <StyledListSection>
                <StyledListContainer>
                    <Row>
                        <Col xs={12} md={9}>
                            <p style={{ marginTop: "25px" }}>&nbsp;</p>
                            {isLoading && <LoadingNewsItem />}
                            {error && <p style={{ color: "red" }}>{error}</p>}
                            {!isLoading && <NewsItemDetail post={newsItem} />}
                        </Col>
                        <Col xs={12} md={3}>
                            <NewsItemSideBar loading={isLoading} post={newsItem} other={otherNews} />
                            <Volunteering />
                            <BecomeAMember />
                        </Col>
                    </Row>
                </StyledListContainer>
            </StyledListSection>
        </>
    )
}